import { render, staticRenderFns } from "./ModuleProfileList.vue?vue&type=template&id=72d5d623"
import script from "./ModuleProfileList.vue?vue&type=script&lang=js"
export * from "./ModuleProfileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports